module.exports = __webpack_public_path__ + "static/img/yj.5ffe1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yj.png
// module id = Ax0T
// module chunks = 0